import ButtonUploadFile from './ButtonUploadFile';

export default ButtonUploadFile;
